import React, { FC, ComponentProps } from 'react'
import cn from 'classnames'
import styles from '@styles/components/CloseButton.module.scss'
import { ActionButton, Icon } from 'ui'
import CrossIcon from '/public/s2_icon_cross.svg'

type Props = Omit<ComponentProps<typeof ActionButton>, 'children'>

const CloseButton: FC<Props> = props => {
  return (
    <ActionButton {...props} className={cn(styles['button'], props.className)}>
      <Icon slot="icon">
        <CrossIcon />
      </Icon>
    </ActionButton>
  )
}

export default CloseButton
